import { L } from '@lib';
import { Tag } from 'antd';

export const InvoiceStatus = {
  Unpaid: 'Unpaid',
  Voided: 'Voided',
  Paid: 'Paid',
};

export const ShowPreviewInvoiceStatus = {
  Completed: 'Completed',
  Ready: 'Ready',
  Paid: 'Paid',
};

export const LocalizedInvoicePaymentTitle = {
  BankTransfer: L('Bank transfer'),
  Cash: L('Payment Received'),
  Card: L('Payment Received'),
  RefundRequest: L('Refund request'),
  Credit: L('Credit issued'),
  CashRefund: L('Refund Completed'),
  CardRefund: L('Refund Completed'),
  Other: L('Other payment'),

  //maybe leftovers? who the fuck knows at this point
  Refund: L('Refund'),
  RefundPaid: L('Refund paid'),
};

export const LocalizedInvoicePaymentMethod = {
  RefundRequest: L('Pending Payout'),
  Credit: L('Invoice adjustment'),
  Cash: L('Cash'),
  Card: L('Card'),
  CashRefund: L('Cash'),
  CardRefund: L('Card'),
  BankTransfer: L('Bank transfer'),
  Other: L('Other payment'),
}

export const LocalizedInvoiceStatus = {
  Unpaid: L('Unpaid'),
  Voided: L('Voided'),
  Paid: L('Paid'),
};

const tagStyle = { minWidth: 100, textAlign: 'center' as const };

export const InvoiceStatusTag = {
  Unpaid: <Tag color="orange" style={tagStyle}>Unpaid</Tag>,
  Voided: <Tag color="red" style={tagStyle}>Voided</Tag>,
  Paid: <Tag color="green" style={tagStyle}>Paid</Tag>,
};

export type LocalizedInvoiceStatusObjectKey = keyof typeof LocalizedInvoiceStatus;
export type InvoiceStatusTagObjectKey = keyof typeof InvoiceStatusTag;
export type LocalizedInvoicePaymentTitleObjectKey = keyof typeof LocalizedInvoicePaymentTitle;
export type LocalizedInvoicePaymentMethodObjectKey = keyof typeof LocalizedInvoicePaymentMethod;